import React, { useState } from "react";
import dayjs from "dayjs";
import {
  LocalizationProvider,
  PickersActionBar,
  StaticTimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Box, Button, Popover, Typography } from "@mui/material";
// import { format } from "date-fns";

export default function ClockArea({
  show,
  setShow,
  date,
  setDate,
  dateEnd,
  setDateEnd,
  detail,
  notRange,
  ...props
}) {
  //   const [value, setValue] = useState();
  const handleClose = () => {
    // setAnchorEl(null);
    setShow(null);
  };
  // const handleFormat = (date) => {
  //   return format(date, "HH:mm"); // HH:mm برای نمایش ساعت با صفر پر شده
  // };

  const open = Boolean(show);
  const id = open ? "simple-popover" : undefined;
  return (
    <Box sx={{ direction: "ltr" }}>
      <Popover
        id={id}
        open={open}
        anchorEl={show}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: detail ? "left" : "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: detail ? "left" : "right",
        }}
        sx={{
          "& .MuiPaper-root ": {
            direction: "ltr !important",
          },
        }}
        {...props}
      >
        <Box display="flex">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <StaticTimePicker
              onChange={(e) => {
                const formattedTime = `${String(e.$H).padStart(
                  2,
                  "0"
                )}:${String(e.$m).padStart(2, "0")}`;
                setDate(formattedTime);
              }}
              defaultValue={dayjs("2022-04-17T00:00")}
              displayStaticWrapperAs="desktop"
            />
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <StaticTimePicker
              onChange={(e) => {
                const formattedTime = `${String(e.$H).padStart(
                  2,
                  "0"
                )}:${String(e.$m).padStart(2, "0")}`;
                setDateEnd(formattedTime);
              }}
              defaultValue={dayjs("2022-04-17T00:00")}
              displayStaticWrapperAs="desktop"
            />
          </LocalizationProvider>
        </Box>
        <Box>
          <Typography
            textAlign={"center"}
            p="10px 20px"
            sx={{ cursor: "pointer" }}
            onClick={handleClose}
          >
            تایید
          </Typography>
        </Box>
      </Popover>
    </Box>
  );
}
